import { createClient, type SupabaseClient } from '@supabase/supabase-js';

/**
 * Cliente Supabase singleton lazy.
 *
 * Init lazy evita explodir testes unitários (que não tocam em rede e
 * rodam sem `.env.local`). O bundle do navegador chama `getSupabase()`
 * só quando uma cena de auth/sync é carregada — momento em que as envs
 * VITE_* já foram injetadas pelo Vite.
 *
 * `persistSession: true` deixa o Supabase guardar o JWT em
 * localStorage; `autoRefreshToken: true` renova antes de expirar — tudo
 * gerenciado pela própria SDK.
 */

let cached: SupabaseClient | null = null;

export function getSupabase(): SupabaseClient {
  if (cached) return cached;
  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
  if (!url || !key) {
    throw new Error(
      'Supabase não configurado — defina VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY em .env.local',
    );
  }
  cached = createClient(url, key, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  });
  return cached;
}
